import { ToolResult } from '../../types';
import { SurroundMaterial, SurroundMaterialOptionsResult } from '../../../surround-material/surround-material.class';

export const getSurroundMaterialOptionsTool = (): ToolResult<SurroundMaterialOptionsResult> => {
	const result = SurroundMaterial.getOptions();

	return {
		success: true,
		message: `Found ${result.options.length} surround material options.`,
		data: result
	};
};
